module.exports = {
  SEE_SIMILAR: "see-similar",
  SAVED_LISTS: "saved-lists",
  SHARED_BOARD: "shared-board"
};
